export const US_REGION = 'US_CA'
export const MEXICO_REGION = 'MEXICO'
